import { render, staticRenderFns } from "./AppInterface.vue?vue&type=template&id=1246408e&scoped=true&"
import script from "./AppInterface.vue?vue&type=script&lang=ts&"
export * from "./AppInterface.vue?vue&type=script&lang=ts&"
import style0 from "./AppInterface.vue?vue&type=style&index=0&id=1246408e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1246408e",
  null
  
)

export default component.exports